module.exports = __webpack_public_path__ + "img/es-ct.b1f766f9.svg";